document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.querySelector('.collection__sidebar__slider');
    const openButton = document.querySelector('.collection__sidebar__open'); // button to show filters
    const closeButton = document.querySelector('.collection__sidebar__close');
    const filterGroups = document.querySelectorAll('.filter-group');
    const DESKTOP_BREAKPOINT = 1024; // adjust if needed

    // ===== Reset classes on page load =====
    function initializeDrawerState() {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
            // Desktop: always visible, no drawer behavior
            drawer.classList.add('expanded');
            drawer.classList.remove('drawer--animated', 'no-mobile-animation');
        } else {
            // Mobile: start closed
            drawer.classList.remove('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== OPEN drawer (mobile only) =====
    function openDrawer() {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            drawer.classList.add('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== CLOSE drawer (mobile only) =====
    function closeDrawer() {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            drawer.classList.remove('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== Prevent filter clicks from closing drawer (desktop only) =====
    function preventFilterCollapse(event) {
        if (window.innerWidth >= DESKTOP_BREAKPOINT && event.target.closest('.filter-group')) {
            event.stopPropagation();
        }
    }

    // Init state
    initializeDrawerState();

    // Re-initialize when resizing (so switching desktop <-> mobile works)
    window.addEventListener('resize', initializeDrawerState);

    // Listeners
    if (openButton) openButton.addEventListener('click', openDrawer);
    document.addEventListener('click', function (e) {
    if (e.target.closest('.collection__sidebar__close')) {
        e.stopPropagation();
        closeDrawer();
    }
    });

    // Prevent sidebar closing on filter clicks (desktop only)
    filterGroups.forEach(filterGroup => {
        filterGroup.addEventListener('click', preventFilterCollapse);
    });
});



(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 15000; // $150.00 in cents
  var lastCartKey = null;
  var updateInProgress = false;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateShippingBar(cart) {

    var container = document.getElementById(
      'shipping-container-cart_page'
    );

    if (!container) {
      return;
    }

    var remaining = Math.max(
      FREE_SHIPPING_THRESHOLD - cart.total_price,
      0
    );

    var progress = Math.min(
      (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100,
      100
    );

    /*
     * Remaining amount
     */
    var priceElement = container.querySelector(
      '.futureblink-price-text'
    );

    if (priceElement) {
      if (remaining > 0) {
        priceElement.textContent = formatMoney(remaining);
      } else {
        priceElement.textContent = '$0.00';
      }
    }

    /*
     * Progress bar
     */
    var progressElement = container.querySelector(
      '.basic-bar-fill'
    );

    if (progressElement) {
      progressElement.style.width = progress + '%';
      progressElement.style.transition = 'width 0.5s';
    }

    /*
     * Message
     */
    var messageElement = container.querySelector(
      '.futureblink-shipping-bar-message-text'
    );

    if (messageElement) {

      if (remaining > 0) {

        messageElement.innerHTML =
          'You’re only <span ' +
          'data-animation-futureblink-shipping="none" ' +
          'class="futureblink-price-text money" ' +
          'style="font-size:16px;color:#ffffff;">' +
          formatMoney(remaining) +
          '</span> away from free shipping!';

      } else {

        messageElement.innerHTML =
          'You qualify for <strong>FREE SHIPPING!</strong>';

      }
    }

    console.log(
      '[Shipping Bar]',
      'Cart:',
      formatMoney(cart.total_price),
      'Remaining:',
      formatMoney(remaining),
      'Progress:',
      progress.toFixed(2) + '%'
    );
  }


  function getCart() {

    if (updateInProgress) {
      return;
    }

    updateInProgress = true;

    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed');
      }

      return response.json();
    })
    .then(function (cart) {

      /*
       * Create a key so we only update when
       * the cart actually changes.
       */
      var cartKey =
        cart.item_count + '-' +
        cart.total_price;

      if (cartKey !== lastCartKey) {

        lastCartKey = cartKey;

        updateShippingBar(cart);
      }

    })
    .catch(function (error) {
      console.error(
        '[Shipping Bar] Cart error:',
        error
      );
    })
    .finally(function () {
      updateInProgress = false;
    });
  }


  /*
   * Initial update
   */
  function init() {

    getCart();

    /*
     * Rebuy event
     */
    document.addEventListener(
      'rebuy:cart.change',
      function () {

        console.log(
          '[Shipping Bar] Rebuy cart changed'
        );

        /*
         * Rebuy may need a moment to finish
         * writing the Shopify cart.
         */
        setTimeout(getCart, 300);
        setTimeout(getCart, 800);
        setTimeout(getCart, 1500);
      }
    );


    /*
     * Shopify/theme cart events
     */
    document.addEventListener(
      'cart:change',
      function () {
        setTimeout(getCart, 300);
      }
    );


    document.addEventListener(
      'theme:cart:refresh',
      function () {
        setTimeout(getCart, 300);
      }
    );


    /*
     * Backup polling.
     *
     * This is important because Rebuy can update
     * the cart without firing an event that the
     * theme/Futureblink listens to.
     */
    setInterval(function () {
      getCart();
    }, 1000);
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();